import { message } from 'antd';

import Utils from '../Assets/Scripts/Utils';

// Constantes para cooldown
const COOLDOWN_MINUTES = 1;
const COOLDOWN_MS = COOLDOWN_MINUTES * 60 * 1000;
const TIMER_INTERVAL = 1000;

// Verifica se pode gerar relatório
export const canGenerateReport = (reportType) => {
  const lastGeneration = localStorage.getItem(`lastReportGeneration_${reportType}`);
  if (!lastGeneration) return true;

  const timeDiff = Date.now() - parseInt(lastGeneration, 10);
  return timeDiff >= COOLDOWN_MS;
};

// Salva timestamp da geração
export const saveReportGeneration = (reportType) => {
  localStorage.setItem(`lastReportGeneration_${reportType}`, Date.now().toString());
};

// Retorna segundos restantes do cooldown
export const getRemainingCooldown = (reportType) => {
  const lastGeneration = localStorage.getItem(`lastReportGeneration_${reportType}`);
  if (!lastGeneration) return 0;

  const timeDiff = Date.now() - parseInt(lastGeneration, 10);
  const remaining = Math.max(0, COOLDOWN_MS - timeDiff);
  return Math.ceil(remaining / TIMER_INTERVAL);
};

// Exporta relatório por email
export const exportReportByEmail = async (endpoint, data, userEmail, reportType) => {
  try {
    if (!canGenerateReport(reportType)) {
      const remainingSeconds = getRemainingCooldown(reportType);
      message.warning(`Aguarde ${remainingSeconds} segundos antes de gerar um novo relatório.`);
      return;
    }

    await fetch(`${process.env.REACT_APP_HOST}${endpoint}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('conecta__token')}`,
        'Content-Type': 'application/json; charset=UTF-8',
        'Cache-Control': 'max-age=31536000',
        Accept: 'application/json',
      },
      body: JSON.stringify({ ...data, UserEmail: userEmail }),
      withCredentials: true,
    });

    saveReportGeneration(reportType);
    message.success(
      'Solicitação de exportação enviada! O relatório será enviado para o e-mail informado quando estiver pronto.'
    );
  } catch (error) {
    Utils.logError(error);
    message.error('Oops. Algo deu errado ao solicitar o relatório!');
  }
};

// Relatório de lista de tarefas
export const exportTaskListReportByEmail = async (data, userEmail) =>
  exportReportByEmail('/ExportData/GenerateTaskListReport', data, userEmail, 'taskList');

export const exportOccurrenceManagementReportByEmail = async (data, userEmail) =>
  exportReportByEmail(
    '/ExportData/GenerateOccurrenceManagementReport',
    data,
    userEmail,
    'occurrenceManagement'
  );
